export const environment = {
  production: true,
  apiUrl: 'https://api.chefyourself.com.au',
  configCatApiKey: 'configcat-sdk-1/4uDcCP1Vk0CHt39gYDtfRw/deeQFkBGC0O-z2JxjThh9Q'
};
